import { Device_State } from './enums';
import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection, Position } from '@iotv/iotv-v3-types';

const typeName = 'WaterPump';

export type WaterPumpProps = {
  purposeType?: string;
  pumpType?: string;
  pumpDiameter?: number;
  maximumFlowRate?: number;
  powerSource?: string;
  solenoid?: string;
  flow?: number;
  volumePumped?: number;
  pumpPressure?: number;
  operatingStatus?: Device_State;
  pumpStartTime?: number;
  pumpStopTime?: number;
  duration?: number;
  location?: Position;
  image?: string;
};

export class WaterPump extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  purposeType?: string;
  pumpType?: string;
  pumpDiameter?: number;
  maximumFlowRate?: number;
  powerSource?: string;
  solenoid?: string;
  flow?: number;
  volumePumped?: number;
  pumpPressure?: number;
  operatingStatus?: Device_State;
  pumpStartTime?: number;
  pumpStopTime?: number;
  duration?: number;
  location?: Position;
  image?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name of Water Pump' },
      purposeType: { type: 'String', editable: true, label: 'Purpose/ Type', name: 'purpose/Type', description: 'Purpose/ type of Water Pump' },
      pumpType: { type: 'String', editable: true, label: 'Pump Type', name: 'pumpType', description: 'Water Pump type' },
      pumpDiameter: { type: 'Number', editable: true, label: 'Pump Diameter', name: 'pumpDiameter', description: 'Diameter of Water Pump pipe - mm' },
      maximumFlowRate: { type: 'Number', editable: true, label: 'Maximum Flow Rate', name: 'maximumFlowRate', description: 'Maximum flow rate ' },
      powerSource: { type: 'String', editable: true, label: 'Power Source', name: 'powerSource', description: 'Power source for Water Pump' },
      solenoid: { type: 'String', editable: true, label: 'Solenoid', name: 'solenoid', description: 'Solenoid type and voltage' },
      flow: { type: 'Number', editable: true, label: 'Flow', name: 'flow', description: 'Water flow  litres/ sec and cubic metres/ sec' },
      volumePumped: { type: 'Number', editable: true, label: 'Volume Pumped', name: 'volumePumped', description: 'Littres, cubic metres' },
      pumpPressure: { type: 'Number', editable: true, label: 'Pump Pressure', name: 'pumpPressure', description: 'Current pump pressure PSi' },
      operatingStatus: { type: 'Enum', editable: true, label: 'Operating Status', name: 'operatingStatus', description: 'On/ off', enumKv: Device_State },
      pumpStartTime: { type: 'Number', editable: true, label: 'Pump Start Time', name: 'pumpStartTime', description: 'Date and time of pump start' },
      pumpStopTime: { type: 'Number', editable: true, label: 'Pump Stop Time', name: 'pumpStopTime', description: 'Date and time of pump stop' },
      duration: {
        type: 'Number',
        editable: true,
        label: 'Duration',
        name: 'duration',
        description: 'Duration between pump start and pump stop - hours/ minutes',
      },
      location: { type: 'object', editable: true, label: 'Location', name: 'location', description: 'Location of  Water Flow Meter (lat/ long)' },
      image: { type: 'String', editable: true, label: 'Image', name: 'image', description: 'Photograph of Water Flow meter' },
      comments: { type: 'String', editable: true, label: 'Comments', name: 'comments', description: 'Free text for info ' },
    };
  };
}
